import { usePublicCompanyLead } from '@/features/publicCompanyLeadsFunnel/hooks/usePublicCompanyLead'
import { useParams } from 'react-router-dom'
import Form from './form'

const Update = () => {
  const { publicCompanyLeadId } = useParams()
  const { data: publicCompanyLead, isPending: isLoadingPublicCompanyLead } = usePublicCompanyLead(
    publicCompanyLeadId || '',
  )

  if (isLoadingPublicCompanyLead || !publicCompanyLead) {
    return null
  }

  return <Form publicCompanyLead={publicCompanyLead} />
}

export default Update
